import { Box, Typography } from '@mui/material';
import Header from '@/Components/MagicLink/Header';
import Section from '@/Components/MagicLink/Section';
import {
    magicLinkCenteredHeroInnerSx,
    magicLinkPageColumnSx,
    magicLinkPageOuterSx,
} from '@/Utils/MagicLink/pageLayout';

const CancelledLinkView = () => {
    return (
        <Box component="main" sx={magicLinkPageOuterSx}>
            <Box sx={magicLinkPageColumnSx}>
                    {/* Centered status block — logo sits directly above the message
                        section, sharing the card's left edge. */}
                    <Box sx={magicLinkCenteredHeroInnerSx}>
                        <Box
                            sx={{
                                width: '100%',
                                maxWidth: 480,
                                display: 'flex',
                                flexDirection: 'column',
                                gap: 2,
                            }}
                        >
                            <Header />

                            <Section>
                                <Box
                                    sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        textAlign: 'center',
                                        gap: 2,
                                        paddingY: 1,
                                    }}
                                >
                                    <Typography variant="h5" component="h1">
                                        Link bol zrušený
                                    </Typography>
                                    <Typography variant="body2" color="text.secondary">
                                        Link bol zrušený. Môžete zatvoriť prehliadač.
                                    </Typography>
                                </Box>
                            </Section>
                        </Box>
                    </Box>
            </Box>
        </Box>
    );
};

export default CancelledLinkView;
